var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessStoriesBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1920 1218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "background_svg__a",
    width: 1920,
    height: 1222,
    x: 0,
    y: -4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040406",
    d: "M0-4h1920v1222H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040406",
    d: "M0 0h1920v1218H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__b)",
    fillOpacity: 0.4,
    d: "M0 0h1920v1218H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__c)",
    fillOpacity: 0.4,
    d: "M0 0h1920v1218H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__d)",
    fillOpacity: 0.02,
    d: "M388.672 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__e)",
    fillOpacity: 0.6,
    d: "M388.672 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__f)",
    fillOpacity: 0.02,
    d: "M430.82 328.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__g)",
    fillOpacity: 0.6,
    d: "M430.82 328.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__h)",
    fillOpacity: 0.02,
    d: "M241.32 364.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__i)",
    fillOpacity: 0.6,
    d: "M241.32 364.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__j)",
    fillOpacity: 0.02,
    d: "M325.609 364.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__k)",
    fillOpacity: 0.6,
    d: "M325.609 364.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__l)",
    fillOpacity: 0.02,
    d: "M367.781 364.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__m)",
    fillOpacity: 0.6,
    d: "M367.781 364.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__n)",
    fillOpacity: 0.02,
    d: "M536.391 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__o)",
    fillOpacity: 0.6,
    d: "M536.391 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__p)",
    fillOpacity: 0.02,
    d: "M177.891 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__q)",
    fillOpacity: 0.6,
    d: "M177.891 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__r)",
    fillOpacity: 0.02,
    d: "M388.672 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__s)",
    fillOpacity: 0.6,
    d: "M388.672 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__t)",
    fillOpacity: 0.02,
    d: "M472.961 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__u)",
    fillOpacity: 0.6,
    d: "M472.961 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__v)",
    fillOpacity: 0.02,
    d: "M325.609 435.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__w)",
    fillOpacity: 0.6,
    d: "M325.609 435.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__x)",
    fillOpacity: 0.02,
    d: "M494.25 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__y)",
    fillOpacity: 0.6,
    d: "M494.25 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__z)",
    fillOpacity: 0.02,
    d: "M536.391 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__A)",
    fillOpacity: 0.6,
    d: "M536.391 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__B)",
    fillOpacity: 0.02,
    d: "M304.781 256.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__C)",
    fillOpacity: 0.6,
    d: "M304.781 256.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__D)",
    fillOpacity: 0.02,
    d: "M431.25 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__E)",
    fillOpacity: 0.6,
    d: "M431.25 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__F)",
    fillOpacity: 0.02,
    d: "M304.422 472.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__G)",
    fillOpacity: 0.6,
    d: "M304.422 472.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__H)",
    fillOpacity: 0.02,
    d: "M430.875 472.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__I)",
    fillOpacity: 0.6,
    d: "M430.875 472.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__J)",
    fillOpacity: 0.06,
    d: "M241.32 292.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__K)",
    fillOpacity: 0.12,
    d: "M241.32 292.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__L)",
    fillOpacity: 0.06,
    d: "M283.461 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__M)",
    fillOpacity: 0.12,
    d: "M283.461 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__N)",
    fillOpacity: 0.06,
    d: "M325.609 292.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__O)",
    fillOpacity: 0.12,
    d: "M325.609 292.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__P)",
    fillOpacity: 0.06,
    d: "M220.031 328.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Q)",
    fillOpacity: 0.12,
    d: "M220.031 328.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__R)",
    fillOpacity: 0.06,
    d: "M346.5 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__S)",
    fillOpacity: 0.12,
    d: "M346.5 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__T)",
    fillOpacity: 0.06,
    d: "M472.961 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__U)",
    fillOpacity: 0.12,
    d: "M472.961 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__V)",
    fillOpacity: 0.06,
    d: "M515.141 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__W)",
    fillOpacity: 0.12,
    d: "M515.141 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__X)",
    fillOpacity: 0.06,
    d: "M409.93 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Y)",
    fillOpacity: 0.12,
    d: "M409.93 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Z)",
    fillOpacity: 0.06,
    d: "M452.07 364.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aa)",
    fillOpacity: 0.12,
    d: "M452.07 364.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ab)",
    fillOpacity: 0.06,
    d: "M494.25 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ac)",
    fillOpacity: 0.12,
    d: "M494.25 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ad)",
    fillOpacity: 0.06,
    d: "M283.828 220.3v22.6l19.775 11.301 19.776-11.301v-22.6L303.603 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ae)",
    fillOpacity: 0.12,
    d: "M283.828 220.3v22.6l19.775 11.301 19.776-11.301v-22.6L303.603 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__af)",
    fillOpacity: 0.06,
    d: "M325.969 220.3v22.6l19.775 11.301 19.775-11.301v-22.6L345.744 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ag)",
    fillOpacity: 0.12,
    d: "M325.969 220.3v22.6l19.775 11.301 19.775-11.301v-22.6L345.744 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ah)",
    fillOpacity: 0.06,
    d: "M368.148 220.3v22.6l19.776 11.301 19.775-11.301v-22.6L387.924 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ai)",
    fillOpacity: 0.12,
    d: "M368.148 220.3v22.6l19.776 11.301 19.775-11.301v-22.6L387.924 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aj)",
    fillOpacity: 0.06,
    d: "M241.32 435.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ak)",
    fillOpacity: 0.12,
    d: "M241.32 435.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__al)",
    fillOpacity: 0.06,
    d: "M283.461 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__am)",
    fillOpacity: 0.12,
    d: "M283.461 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__an)",
    fillOpacity: 0.06,
    d: "M367.781 435.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ao)",
    fillOpacity: 0.12,
    d: "M367.781 435.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ap)",
    fillOpacity: 0.06,
    d: "M220.484 256.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aq)",
    fillOpacity: 0.12,
    d: "M220.484 256.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ar)",
    fillOpacity: 0.06,
    d: "M262.633 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__as)",
    fillOpacity: 0.12,
    d: "M262.633 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__at)",
    fillOpacity: 0.06,
    d: "M389.102 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__au)",
    fillOpacity: 0.12,
    d: "M389.102 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__av)",
    fillOpacity: 0.06,
    d: "M388.734 472.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aw)",
    fillOpacity: 0.12,
    d: "M388.734 472.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ax)",
    fillOpacity: 0.06,
    d: "M473.031 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ay)",
    fillOpacity: 0.12,
    d: "M473.031 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__az)",
    fillOpacity: 0.06,
    d: "M515.195 472.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aA)",
    fillOpacity: 0.12,
    d: "M515.195 472.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aB)",
    fillOpacity: 0.12,
    d: "M157 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aC)",
    fillOpacity: 0.16,
    d: "M157 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aD)",
    fillOpacity: 0.12,
    d: "M199.141 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aE)",
    fillOpacity: 0.16,
    d: "M199.141 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aF)",
    fillOpacity: 0.12,
    d: "M367.781 292.464v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aG)",
    fillOpacity: 0.16,
    d: "M367.781 292.464v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aH)",
    fillOpacity: 0.12,
    d: "M409.93 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aI)",
    fillOpacity: 0.16,
    d: "M409.93 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aJ)",
    fillOpacity: 0.12,
    d: "M452.07 292.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aK)",
    fillOpacity: 0.16,
    d: "M452.07 292.464v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aL)",
    fillOpacity: 0.12,
    d: "M494.25 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aM)",
    fillOpacity: 0.16,
    d: "M494.25 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aN)",
    fillOpacity: 0.12,
    d: "M536.391 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aO)",
    fillOpacity: 0.16,
    d: "M536.391 292.464v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aP)",
    fillOpacity: 0.12,
    d: "M177.891 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aQ)",
    fillOpacity: 0.16,
    d: "M177.891 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aR)",
    fillOpacity: 0.12,
    d: "M262.203 328.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aS)",
    fillOpacity: 0.16,
    d: "M262.203 328.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aT)",
    fillOpacity: 0.12,
    d: "M304.352 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aU)",
    fillOpacity: 0.16,
    d: "M304.352 328.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aV)",
    fillOpacity: 0.12,
    d: "M157 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aW)",
    fillOpacity: 0.16,
    d: "M157 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aX)",
    fillOpacity: 0.12,
    d: "M199.141 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aY)",
    fillOpacity: 0.16,
    d: "M199.141 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aZ)",
    fillOpacity: 0.12,
    d: "M220.031 400.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ba)",
    fillOpacity: 0.16,
    d: "M220.031 400.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bb)",
    fillOpacity: 0.12,
    d: "M262.203 400.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bc)",
    fillOpacity: 0.16,
    d: "M262.203 400.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bd)",
    fillOpacity: 0.12,
    d: "M304.352 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__be)",
    fillOpacity: 0.16,
    d: "M304.352 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bf)",
    fillOpacity: 0.12,
    d: "M346.5 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bg)",
    fillOpacity: 0.16,
    d: "M346.5 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bh)",
    fillOpacity: 0.12,
    d: "M430.82 400.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bi)",
    fillOpacity: 0.16,
    d: "M430.82 400.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bj)",
    fillOpacity: 0.12,
    d: "M515.141 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bk)",
    fillOpacity: 0.16,
    d: "M515.141 400.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bl)",
    fillOpacity: 0.12,
    d: "M199.516 220.3v22.6l19.775 11.301 19.775-11.301v-22.6L219.291 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bm)",
    fillOpacity: 0.16,
    d: "M199.516 220.3v22.6l19.775 11.301 19.775-11.301v-22.6L219.291 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bn)",
    fillOpacity: 0.12,
    d: "M241.68 220.3v22.6l19.775 11.301L281.23 242.9v-22.6L261.455 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bo)",
    fillOpacity: 0.16,
    d: "M241.68 220.3v22.6l19.775 11.301L281.23 242.9v-22.6L261.455 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bp)",
    fillOpacity: 0.12,
    d: "M410.289 220.3v22.6l19.775 11.301L449.84 242.9v-22.6L430.064 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bq)",
    fillOpacity: 0.16,
    d: "M410.289 220.3v22.6l19.775 11.301L449.84 242.9v-22.6L430.064 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__br)",
    fillOpacity: 0.12,
    d: "M452.438 220.3v22.6l19.775 11.301 19.775-11.301v-22.6L472.213 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bs)",
    fillOpacity: 0.16,
    d: "M452.438 220.3v22.6l19.775 11.301 19.775-11.301v-22.6L472.213 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bt)",
    fillOpacity: 0.12,
    d: "M494.609 220.3v22.6l19.776 11.301L534.16 242.9v-22.6L514.385 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bu)",
    fillOpacity: 0.16,
    d: "M494.609 220.3v22.6l19.776 11.301L534.16 242.9v-22.6L514.385 209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bv)",
    fillOpacity: 0.12,
    d: "M157 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bw)",
    fillOpacity: 0.16,
    d: "M157 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bx)",
    fillOpacity: 0.12,
    d: "M199.141 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__by)",
    fillOpacity: 0.16,
    d: "M199.141 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bz)",
    fillOpacity: 0.12,
    d: "M409.93 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bA)",
    fillOpacity: 0.16,
    d: "M409.93 435.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bB)",
    fillOpacity: 0.12,
    d: "M452.07 435.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bC)",
    fillOpacity: 0.16,
    d: "M452.07 435.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bD)",
    fillOpacity: 0.12,
    d: "M178.32 256.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bE)",
    fillOpacity: 0.16,
    d: "M178.32 256.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bF)",
    fillOpacity: 0.12,
    d: "M346.953 256.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bG)",
    fillOpacity: 0.16,
    d: "M346.953 256.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bH)",
    fillOpacity: 0.12,
    d: "M473.391 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bI)",
    fillOpacity: 0.16,
    d: "M473.391 256.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bJ)",
    fillOpacity: 0.12,
    d: "M515.57 256.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bK)",
    fillOpacity: 0.16,
    d: "M515.57 256.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bL)",
    fillOpacity: 0.12,
    d: "M177.953 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bM)",
    fillOpacity: 0.16,
    d: "M177.953 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bN)",
    fillOpacity: 0.12,
    d: "M220.117 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bO)",
    fillOpacity: 0.16,
    d: "M220.117 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bP)",
    fillOpacity: 0.12,
    d: "M262.266 472.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bQ)",
    fillOpacity: 0.16,
    d: "M262.266 472.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bR)",
    fillOpacity: 0.12,
    d: "M346.578 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bS)",
    fillOpacity: 0.16,
    d: "M346.578 472.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bT)",
    fillOpacity: 0.12,
    d: "M283.461 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bU)",
    fillOpacity: 0.16,
    d: "M283.461 364.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bV)",
    fillOpacity: 0.6,
    d: "M1319.67 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bW)",
    fillOpacity: 0.6,
    d: "M1361.82 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bX)",
    fillOpacity: 0.6,
    d: "M1172.32 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bY)",
    fillOpacity: 0.6,
    d: "M1256.61 1066.18v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bZ)",
    fillOpacity: 0.6,
    d: "M1298.78 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ca)",
    fillOpacity: 0.6,
    d: "M1467.39 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cb)",
    fillOpacity: 0.6,
    d: "M1108.89 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cc)",
    fillOpacity: 0.6,
    d: "M1319.67 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cd)",
    fillOpacity: 0.6,
    d: "M1403.96 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ce)",
    fillOpacity: 0.6,
    d: "M1256.61 1137.97v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cf)",
    fillOpacity: 0.6,
    d: "M1425.25 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cg)",
    fillOpacity: 0.6,
    d: "M1467.39 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ch)",
    fillOpacity: 0.6,
    d: "M1235.78 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ci)",
    fillOpacity: 0.6,
    d: "M1362.25 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cj)",
    fillOpacity: 0.6,
    d: "M1235.42 1174.25v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ck)",
    fillOpacity: 0.6,
    d: "M1361.88 1174.25v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cl)",
    fillOpacity: 0.2,
    d: "M1172.32 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cm)",
    fillOpacity: 0.2,
    d: "M1214.46 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cn)",
    fillOpacity: 0.2,
    d: "M1256.61 994.464v22.596l19.77 11.3 19.78-11.3v-22.596l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__co)",
    fillOpacity: 0.2,
    d: "M1151.03 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cp)",
    fillOpacity: 0.2,
    d: "M1277.5 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cq)",
    fillOpacity: 0.2,
    d: "M1403.96 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cr)",
    fillOpacity: 0.2,
    d: "M1446.14 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cs)",
    fillOpacity: 0.2,
    d: "M1340.93 1066.18v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ct)",
    fillOpacity: 0.2,
    d: "M1383.07 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cu)",
    fillOpacity: 0.2,
    d: "M1425.25 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cv)",
    fillOpacity: 0.2,
    d: "M1214.83 922.3v22.6l19.77 11.301 19.78-11.301v-22.6L1234.6 911z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cw)",
    fillOpacity: 0.2,
    d: "M1256.97 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cx)",
    fillOpacity: 0.2,
    d: "M1299.15 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cy)",
    fillOpacity: 0.2,
    d: "M1172.32 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cz)",
    fillOpacity: 0.2,
    d: "M1214.46 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cA)",
    fillOpacity: 0.2,
    d: "M1298.78 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cB)",
    fillOpacity: 0.2,
    d: "M1151.48 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cC)",
    fillOpacity: 0.2,
    d: "M1193.63 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cD)",
    fillOpacity: 0.2,
    d: "M1320.1 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cE)",
    fillOpacity: 0.2,
    d: "M1319.73 1174.25v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cF)",
    fillOpacity: 0.2,
    d: "M1404.03 1174.25v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cG)",
    fillOpacity: 0.2,
    d: "M1446.2 1174.25v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cH)",
    fillOpacity: 0.08,
    d: "M1299.77 852.095v22.191l19.29 11.096 19.28-11.096v-22.191L1319.06 841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cI)",
    fillOpacity: 0.08,
    d: "M1340.87 852.095v22.191l19.28 11.096 19.28-11.096v-22.191L1360.15 841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cJ)",
    fillOpacity: 0.08,
    d: "M1382 852.095v22.191l19.28 11.096 19.29-11.096v-22.191L1401.28 841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cK)",
    fillOpacity: 0.08,
    d: "M1402.43 887.714v22.191L1421.72 921l19.28-11.095v-22.191l-19.28-11.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cL)",
    fillOpacity: 0.08,
    d: "m1483.29 887.452-19.22-11.095-19.25 11.153-.03 22.248 19.21 11.096 19.25-11.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cM)",
    fillOpacity: 0.08,
    d: "m1462.74 923.041-19.22-11.095-19.25 11.153-.03 22.248 19.22 11.096 19.25-11.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cN)",
    fillOpacity: 0.08,
    d: "m1442.17 958.663-19.21-11.095-19.26 11.153-.03 22.248 19.22 11.095 19.25-11.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cO)",
    fillOpacity: 0.08,
    d: "m1401.11 958.549-19.22-11.095-19.25 11.153-.03 22.248 19.22 11.096 19.25-11.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cP)",
    fillOpacity: 0.06,
    d: "M1088 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cQ)",
    fillOpacity: 0.06,
    d: "M1130.14 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cR)",
    fillOpacity: 0.06,
    d: "M1298.78 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cS)",
    fillOpacity: 0.06,
    d: "M1340.93 994.464v22.596l19.77 11.3 19.78-11.3v-22.596l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cT)",
    fillOpacity: 0.06,
    d: "M1383.07 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cU)",
    fillOpacity: 0.06,
    d: "M1425.25 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cV)",
    fillOpacity: 0.06,
    d: "M1467.39 994.464v22.596l19.78 11.3 19.77-11.3v-22.596l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cW)",
    fillOpacity: 0.06,
    d: "M1108.89 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cX)",
    fillOpacity: 0.06,
    d: "M1193.2 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cY)",
    fillOpacity: 0.06,
    d: "M1235.35 1030.1v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cZ)",
    fillOpacity: 0.06,
    d: "M1088 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__da)",
    fillOpacity: 0.06,
    d: "M1130.14 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__db)",
    fillOpacity: 0.06,
    d: "M1151.03 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dc)",
    fillOpacity: 0.06,
    d: "M1193.2 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dd)",
    fillOpacity: 0.06,
    d: "M1235.35 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__de)",
    fillOpacity: 0.06,
    d: "M1277.5 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__df)",
    fillOpacity: 0.06,
    d: "M1361.82 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dg)",
    fillOpacity: 0.06,
    d: "M1446.14 1102.2v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dh)",
    fillOpacity: 0.06,
    d: "M1130.52 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__di)",
    fillOpacity: 0.06,
    d: "M1172.68 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dj)",
    fillOpacity: 0.06,
    d: "M1341.29 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dk)",
    fillOpacity: 0.06,
    d: "M1383.44 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dl)",
    fillOpacity: 0.06,
    d: "M1425.61 922.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dm)",
    fillOpacity: 0.06,
    d: "M1088 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dn)",
    fillOpacity: 0.06,
    d: "M1130.14 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__do)",
    fillOpacity: 0.06,
    d: "M1340.93 1137.97v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dp)",
    fillOpacity: 0.06,
    d: "M1383.07 1137.97v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dq)",
    fillOpacity: 0.06,
    d: "M1109.32 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dr)",
    fillOpacity: 0.06,
    d: "M1277.95 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ds)",
    fillOpacity: 0.06,
    d: "M1404.39 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dt)",
    fillOpacity: 0.06,
    d: "M1446.57 958.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__du)",
    fillOpacity: 0.06,
    d: "M1108.95 1174.25v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dv)",
    fillOpacity: 0.06,
    d: "M1151.12 1174.25v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dw)",
    fillOpacity: 0.06,
    d: "M1193.27 1174.25v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dx)",
    fillOpacity: 0.06,
    d: "M1277.58 1174.25v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dy)",
    fillOpacity: 0.06,
    d: "M1214.46 1066.18v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141722",
    d: "M1130 1066.3v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dz)",
    strokeLinecap: "round",
    strokeOpacity: 0.36,
    d: "M1130 1066.3v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dA)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1130 1066.3v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161925",
    d: "M1151 1030.3v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dB)",
    strokeLinecap: "round",
    strokeOpacity: 0.36,
    d: "M1151 1030.3v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dC)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1151 1030.3v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171B27",
    d: "M1362.2 887.017v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dD)",
    strokeLinecap: "round",
    strokeOpacity: 0.19,
    d: "m1381.97 920.341-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dE)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m1381.97 920.341-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171A26",
    d: "M1383.45 922.796v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dF)",
    strokeLinecap: "round",
    strokeOpacity: 0.12,
    d: "m1403.23 956.121-19.28-11.015v-22.02l19.28-11.014 19.27 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dG)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m1403.23 956.121-19.28-11.015v-22.02l19.28-11.014 19.27 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181A26",
    d: "M1341.3 922.829v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dH)",
    strokeLinecap: "round",
    strokeOpacity: 0.4,
    d: "m1361.07 956.154-19.27-11.014v-22.02l19.27-11.015 19.28 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dI)",
    strokeOpacity: 0.68,
    d: "m1400.01 911.336-17.93 11m0 0v23.5l21.5 12.216m-21.5-35.716-19-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E1018",
    d: "M347.191 184.589v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dJ)",
    strokeLinecap: "round",
    strokeOpacity: 0.19,
    d: "m366.967 217.914-19.276-11.015v-22.02l19.276-11.014 19.275 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dK)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m366.967 217.914-19.276-11.015v-22.02l19.276-11.014 19.275 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10121B",
    d: "M325.906 220.243v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dL)",
    strokeLinecap: "round",
    strokeOpacity: 0.06,
    d: "m345.681 253.568-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dM)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m345.681 253.568-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13151F",
    d: "M241.203 364.21v22.601l19.775 11.3 19.776-11.3V364.21l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dN)",
    strokeLinecap: "round",
    strokeOpacity: 0.25,
    d: "m260.978 397.535-19.275-11.015V364.5l19.275-11.014 19.276 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dO)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m260.978 397.535-19.275-11.015V364.5l19.275-11.014 19.276 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11141D",
    d: "M199.051 364.269v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dP)",
    strokeLinecap: "round",
    strokeOpacity: 0.25,
    d: "m218.826 397.593-19.275-11.014v-22.02l19.275-11.014 19.275 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dQ)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m218.826 397.593-19.275-11.014v-22.02l19.275-11.014 19.275 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dR)",
    strokeOpacity: 0.68,
    d: "M240 364v22.5m0 0 21.5 12.5M240 386.5 219.5 399m42 0v23.5L240 434m21.5-35 19-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10121B",
    d: "M219.918 399.865v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dS)",
    strokeLinecap: "round",
    strokeOpacity: 0.07,
    d: "m239.693 433.189-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dT)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m239.693 433.189-19.275-11.014v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11141D",
    d: "M262.199 399.984v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dU)",
    strokeLinecap: "round",
    strokeOpacity: 0.25,
    d: "m281.974 433.308-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dV)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m281.974 433.308-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-1.24 21910.995 -22110.467)scale(663.655 649.932)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#383D58",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#2F3349",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#222435",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#040406",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.634 904.211 233.31)scale(479.021 718.207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#383D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#383D58",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040406",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 14.037 498.809)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ah",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 252 393.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 128.12 206.495)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ba",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__br",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__by",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 252 398.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#3E475F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 144.386 149.083)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D26",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ca",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ce",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ch",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ci",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ck",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(57.513 -382.63 1657.488)scale(83.1775 108.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__co",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ct",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1181 1080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 790.136 312.97)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 790.136 312.97)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 790.136 312.97)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 790.136 312.97)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 2789.194 -2459.93)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 2789.194 -2459.93)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 2789.194 -2459.93)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 2789.194 -2459.93)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__da",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__db",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__de",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__df",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__di",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__do",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ds",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__du",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1230 1070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.49998 23.49998 -26.31997 35.27997 1130 1062.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-35.50001 -9.00003 10.08004 -39.76004 1183.5 1090)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(22.203 -2047.788 3380.147)scale(52.9245 59.2754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-117.553 916.156 175.89)scale(38.9134 43.583)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(43.50002 -17.50004 19.60005 48.72004 1351 913.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-55.80845 30.21707 -33.84314 -62.5055 1418 878.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(57.5 -18.49998 20.72 64.40005 1374 948.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-68.55058 45.99638 -51.51597 -76.7767 1452 898.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(57.5 -18.49998 20.72 64.40005 1331.85 948.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-58.99993 4.00049 -4.48055 -66.07997 413.5 196)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(37.50001 5.5 -6.16 41.99997 347 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-34.00004 -6.00002 6.72001 -38.08 372.5 234.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.45673 -1.74959 1.95953 44.19148 326 229.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.81519 31.0118 -34.73319 -33.39298 280.754 358.476)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 246.06 394.715)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.762 40.499 230.192)scale(67.4435 75.5367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 203.908 394.773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.762 42.013 253.22)scale(67.4435 75.5367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 224.775 430.369)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.762 63.123 263.874)scale(67.4435 75.5367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 267.056 430.488)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__d",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__f",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__h",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__j",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__l",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__n",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__p",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__r",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__t",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__v",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__x",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__z",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__B",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__D",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__F",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__H",
    x1: 262,
    x2: 339.5,
    y1: 426.271,
    y2: 554.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__dI",
    x1: 1363,
    x2: 1395.34,
    y1: 915.5,
    y2: 923.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#0C0C0C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__dR",
    x1: 265.5,
    x2: 236.494,
    y1: 380,
    y2: 433.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStoriesBg);
export default __webpack_public_path__ + "static/media/success-stories-bg.4981a8f6e1086ac8c72e3035181cdc40.svg";
export { ForwardRef as ReactComponent };